export default __webpack_public_path__ + "static/media/guest_cameraChange.413ebf64.svg";